import { ValueOf } from '~/types/types';
import { loadPPGResults } from './actions';
import { DataStatus } from '~/types/enums';
import { PPGRecordResponseDTO } from '@kulak91/everbeat-api-client';
import { createSlice } from '@reduxjs/toolkit';

type State = {
  loadPPGResultsStatus: ValueOf<typeof DataStatus>;
  ppgResults: PPGRecordResponseDTO[];
};

const initialState: State = {
  loadPPGResultsStatus: DataStatus.IDLE,
  ppgResults: [],
};

const { reducer, actions } = createSlice({
  initialState,
  name: 'ppg',
  reducers: {},
  extraReducers(builder) {
    builder.addCase(loadPPGResults.fulfilled, (state, { payload }) => {
      state.loadPPGResultsStatus = DataStatus.SUCCEEDED;
      state.ppgResults = payload.data;
    });
    builder.addCase(loadPPGResults.pending, (state) => {
      state.loadPPGResultsStatus = DataStatus.LOADING;
    });
    builder.addCase(loadPPGResults.rejected, (state) => {
      state.loadPPGResultsStatus = DataStatus.FAILED;
    });
  },
});

export { actions, reducer };
